import { PageLayout } from '@app/PageLayout';
import { DisplayWrapper } from '@core/DisplayWrapper/DisplayWrapper';
import { Grid, Breadcrumb, IconName, Heading, HeadingType } from '@gcl/react-core';
import { routes } from '@routes/routes.models';
import { Tab, Tabs } from '@core/Tabs/Tab';
import { useNavigate } from '@routes/routes.hooks';
import { useBreakPoints } from '@common/breakpoints.hooks';
import { SettingUserPreferenceTab } from './SettingUserPreferenceTab';
import { MySignatureDetail } from './MySignatureDetail';

export const SettingPage = () => {
  const { navigate } = useNavigate();
  const { isXs, isSm, isMd } = useBreakPoints();
  const isMobileSize = isSm || isXs || isMd;

  return (
    <PageLayout
      renderMainContent={({ isMenuHidden }) => (
        <Grid className={`${isMobileSize ? 'gcl-m-md' : 'gcl-px-md gcl-mx-xl gcl-my-md'}`}>
          <div className="gcl-pb-m">
            <Breadcrumb
              items={[
                {
                  text: 'Home',
                  prefixIconName: 'House' as IconName,
                  onClick: () => {
                    navigate(routes.home.path);
                  },
                },
                {
                  text: `Setting`,
                  prefixIconName: 'JournalText' as IconName,
                  active: true,
                },
              ]}
            />
          </div>
          <Heading as={HeadingType.h1} styledAs={HeadingType.h2} className="gcl-pb-lg">
            Setting
          </Heading>
          <DisplayWrapper
            isLoading={false}
            loaderProps={[
              { suffixBlankRow: true, numberOfRows: 1, lineHeight: 20, lineWidth: 20 },
              { suffixBlankRow: true, numberOfRows: 1, lineHeight: 20, lineWidth: 350 },
              { suffixBlankRow: true, numberOfRows: 1, lineHeight: 20, lineWidth: 300 },
              { suffixBlankRow: true, numberOfRows: 1, lineHeight: 20, lineWidth: 320 },
            ]}
          >
            <Tabs>
              <Tab headerText="My Profile">
                <MySignatureDetail />
              </Tab>

              <Tab headerText="User Preference">
                <SettingUserPreferenceTab />
              </Tab>
            </Tabs>
          </DisplayWrapper>
        </Grid>
      )}
    />
  );
};
